<div class="container px-0">
  <div class="row">
    <div class="col-12">
      <img class="w-100" [src]="url" alt="">
    </div>
    <!-- <div class="col-12 col-md-6">
      <img class="w-100" src="https://static.monific.com/assets/assets-app/examples/id-back.jpg" alt="">
    </div> -->
  </div>
</div>
